import { ActivityType, TierIiReportKind } from "generated-graphql/graphql";

import { isLepcPortalActivity } from "../useRelevantPortalCredential";

export const inferActionFromDescription = (description?: string | null): string => {
  if (isLepcPortalActivity(description)) {
    return "inputDataLepc";
  }

  const desc = description?.toLowerCase() ?? "";
  if (desc.includes("download receipt")) {
    return "finalizeSubmission";
  }
  if (desc.includes("downloadreport")) {
    return "downloadReport";
  }
  return "inputData";
};

export const getDefaultInputActionForReportKind = (
  reportKind?: TierIiReportKind | null
): string => {
  if (reportKind === TierIiReportKind.Revision) {
    return "inputDataRevision";
  }
  if (reportKind === TierIiReportKind.NewlyNotReporting) {
    return "inputDataNewlyNotReporting";
  }

  return "inputData";
};

export const getGeppettoAction = (
  activityType?: ActivityType,
  jobAction?: string | null,
  activityDescription?: string | null,
  reportKind?: TierIiReportKind | null
) => {
  if (jobAction) {
    return jobAction;
  }

  if (activityType === ActivityType.Geppetto) {
    const inferredAction = inferActionFromDescription(activityDescription);
    if (inferredAction === "inputData") {
      return getDefaultInputActionForReportKind(reportKind);
    }

    return inferredAction;
  }

  if (activityType === ActivityType.CollectEvidence) {
    return "collectEvidenceOfCompletion";
  }

  return "";
};

export const buildGeppettoCommand = ({
  action,
  reportingYear,
  reportKind,
  facilityId,
  jobId,
  credentialId,
  reportId,
  sectionIds,
}: {
  action: string;
  reportingYear?: number | null;
  reportKind?: string | null;
  facilityId?: string | null;
  jobId?: string | null;
  credentialId?: string | null;
  reportId?: string | null;
  sectionIds?: string[];
}) => {
  const parts = [
    `yarn encamp geppetto --action ${action} --reporting-year ${reportingYear} --report-kind ${reportKind} --facility-id ${facilityId}`,
    jobId ? `--job-id ${jobId}` : "--create-job",
    credentialId ? `--credential-id ${credentialId}` : "",
    reportId ? `--report-id ${reportId}` : "",
    // CSV wire format: section IDs are 1-2 digit numerics today, so a bare
    // comma-join is safe. The CLI splits on `,` (packages/encamp-cli/src/commands/geppetto.ts)
    // and the geppetto debug entrypoint does the same. If section IDs ever
    // become non-numeric tokens that can contain commas, switch to JSON encoding
    // and update both consumers in lockstep.
    sectionIds && sectionIds.length > 0 ? `--sections "${sectionIds.join(",")}"` : "",
  ];

  return parts.filter(Boolean).join(" ");
};
